// extracted by mini-css-extract-plugin
export default {"body":"RegistrationSendLetterScreen_body__lFwDL"};